module.exports = {
  label: {
    headerTitle: 'Group Management',
    AddheaderTitle: 'Add Group',
    EditheaderTitle: 'Edit Group',
    name: 'Group Name',
    addPerson: 'Add a person',
    relationship: 'Relationship with me',
    personName: 'Name',
    changeLogo: 'Do you want to change Photo?',
    selectRelationType: "Select relationship type",
    personNumber: "Person",
    uploadThePhoto: 'Upload The Photo',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      edit: 'Edit'
    },
    buttons: {
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel',
      AddNewMember: 'Add New Member'
    }
  }
}
